import React, { useState } from "react";
import { TextField, Button, Box, Typography, Grid } from "@mui/material";
import { ReactComponent as PlushIcon } from "../../assets/dashboardIcons/plusicon.svg";
import { ReactComponent as Wifi } from "../../assets/dashboardIcons/wifiIcon.svg";
import { LocalizationProvider, DateTimePicker, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useForm, Controller } from "react-hook-form";
import MenuWithPDF from "../filter/MenuWithPDF";
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import { useSelector } from "react-redux";
import produzioniFormAPI from "../../services/produzioniFormApi";
dayjs.locale('it');

const TableInputFeildFermentazione = ({ option, rows, setRows, activeStep }) => {
    const singleProduzioneID = useSelector((state) => state.produzioni.singleProduzioneId);
    const { control } = useForm();
    // const [rows, setRows] = useState([
    //     { id: 1, date: null, tempFermentazione: "", phMosto: "", alcolPotenziale: "", densitaMosto: "" },
    //     { id: 2, date: null, tempFermentazione: "", phMosto: "", alcolPotenziale: "", densitaMosto: "" },
    //     { id: 3, date: null, tempFermentazione: "", phMosto: "", alcolPotenziale: "", densitaMosto: "" },
    // ]);

    const handleInputChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const addRow = () => {
        setRows([
            ...rows,
            { company_id: Number(localStorage.getItem('company_id')) || "", step: activeStep, prod_id: singleProduzioneID, fermentazione: null, temp_fermentazione: "", ph_del_mosto: "", alcol_potenziale: "", densita_mosto: "" }
        ]);
    };
    const handleDelete = async (index) => {
        const row = rows[index];
    
        if (row.id) {
          try {
            await produzioniFormAPI.deleteStepFormRow({
                id: row.id, 
                formName: "fermentazione"
            });
          } catch (err) {
            console.error("Error deleting row from server:", err);
            return;
          }
        }

        setRows((prev) => prev.filter((_, i) => i !== index));
      };

    return (
        <Box className="tableInput" sx={{ maxWidth: "100%", padding: 2 }}>
            <h3 className="sectiontitleSmall">Fermentazione e macerazione</h3>

            <Grid container spacing={1} sx={{ marginBottom: 1, fontWeight: "bold", color: "gray" }}>
                <Grid size={.5}><Typography>ID</Typography></Grid>
                <Grid size={2.3}><Typography>Data inizio fermentazione</Typography></Grid>
                <Grid size={2.3}>
                    <Box className="inputBoxIcon heading">
                        <p>Temp. fermentazione</p>
                        <Wifi className="wifiIcon" />
                    </Box>
                </Grid>
                <Grid size={2.3}>
                    <Box className="inputBoxIcon heading">
                        <p>PH del mosto</p>
                        <Wifi className="wifiIcon" />
                    </Box>
                </Grid>
                <Grid size={2.25}>
                    <Box className="inputBoxIcon heading">
                        <p>Alcol potenziale</p>
                        <Wifi className="wifiIcon" />
                    </Box>
                </Grid>
                <Grid size={2.25}>
                    <Box className="inputBoxIcon heading">
                        <p>Densità del mosto</p>
                        <Wifi className="wifiIcon" />
                    </Box>
                </Grid>
            </Grid>

            {rows?.map((row, index) => (
                <>
                    <Grid container spacing={1} key={index} sx={{ marginBottom: 1 }}>
                        <Grid size={.5}>
                            <TextField
                                className="customTextBox"
                                label="ID"
                                size="small"
                                value={row?.id || index}
                                disabled
                            />
                        </Grid>
                        <Grid size={2.3}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                                <Controller
                                    name={`date-${index}`}
                                    control={control}
                                    render={({ field }) => (
                                        <DatePicker
                                            label="Data inizio fermentazione"
                                            className='datePickerField'
                                            value={row.fermentazione ? dayjs(row.fermentazione) : null}
                                            onChange={(newValue) => {
                                                const formattedDate = dayjs(newValue).format("YYYY-MM-DD");
                                                handleInputChange(index, "fermentazione", formattedDate);
                                                field.onChange(formattedDate);
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} fullWidth margin="normal" size="small" />
                                            )}
                                        />
                                    )}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={2.3}>
                            <Box className="inputBoxIcon">
                                <TextField
                                defaultValue=""
                                    className="customTextBox"
                                    label="Temp. fermentazione"
                                    onChange={(e) => handleInputChange(index, "temp_fermentazione", e.target.value)}
                                    size="small"
                                    value={row.temp_fermentazione}
                                />
                                <Wifi className="wifiIcon" />
                            </Box>
                        </Grid>
                        <Grid size={2.3}>
                            <Box className="inputBoxIcon">
                                <TextField
                                defaultValue=""
                                    className="customTextBox"
                                    label="PH del mosto"
                                    onChange={(e) => handleInputChange(index, "ph_del_mosto", e.target.value)}
                                    size="small"
                                    value={row.ph_del_mosto}
                                />
                                <Wifi className="wifiIcon" />
                            </Box>
                        </Grid>
                        <Grid size={2.25}>
                            <Box className="inputBoxIcon">
                                <TextField
                                defaultValue=""
                                    className="customTextBox"
                                    label="Alcol potenziale"
                                    onChange={(e) => handleInputChange(index, "alcol_potenziale", e.target.value)}
                                    size="small"
                                    value={row.alcol_potenziale}
                                />
                                <Wifi className="wifiIcon" />
                            </Box>
                        </Grid>
                        <Grid size={2.25}>
                            <Box className="inputBoxIcon">
                                <TextField
                                defaultValue=""
                                    className="customTextBox"
                                    label="Densità del mosto"
                                    onChange={(e) => handleInputChange(index, "densita_mosto", e.target.value)}
                                    size="small"
                                    value={row.densita_mosto}
                                />
                                <Wifi className="wifiIcon" />
                            </Box>
                        </Grid>
                        <Grid size={.1}>
                            <MenuWithPDF
                                options={option}
                                handleDelete={(event) => {
                                    event?.stopPropagation();
                                    handleDelete(index);
                                }}
                            />
                        </Grid>
                    </Grid>

                </>
            ))}

            <Button
                variant="body"
                onClick={addRow}
                sx={{
                    cursor: 'pointer', color: "#225CA6", mt: 1, gap: "6px",
                    fontFamily: '"Public Sans", sans-serif !important',
                    '&:hover': {
                        color: '#57C700',
                        background: "transparent"
                    }
                }}
            >
                <PlushIcon /> aggiungi lotto di fermentazione
            </Button>
        </Box>
    );
};

export default TableInputFeildFermentazione;
